import brasil from './brasil.jpg';
import m11 from './11.jpg';
import m12 from './12.jpg';
import m13 from './13.jpg';
import m14 from './14.jpg';
import m15 from './15.jpg';
import m16 from './16.jpg';
import m17 from './17.jpg';
import m21 from './21.jpg';
import m22 from './22.jpg';
import m23 from './23.jpg';
import m24 from './24.jpg';
import m25 from './25.jpg';
import m26 from './26.jpg';
import m27 from './27.jpg';
import m28 from './28.jpg';
import m29 from './29.jpg';
import m31 from './31.jpg';
import m32 from './32.jpg';
import m33 from './33.jpg';
import m35 from './35.jpg';
import m41 from './41.jpg';
import m42 from './42.jpg';
import m43 from './43.jpg';
import m50 from './50.jpg';
import m51 from './51.jpg';
import m52 from './52.jpg';
import m53 from './53.jpg';

const images = {
  brasil,
  11: m11,
  12: m12,
  13: m13,
  14: m14,
  15: m15,
  16: m16,
  17: m17,
  21: m21,
  22: m22,
  23: m23,
  24: m24,
  25: m25,
  26: m26,
  27: m27,
  28: m28,
  29: m29,
  31: m31,
  32: m32,
  33: m33,
  35: m35,
  41: m41,
  42: m42,
  43: m43,
  50: m50,
  51: m51,
  52: m52,
  53: m53,
};

export default images;
